var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06993 5.66933C8.90788 3.83138 11.4007 2.79883 13.9999 2.79883C16.5992 2.79883 19.092 3.83138 20.9299 5.66933C22.7679 7.50728 23.8004 10.0001 23.8004 12.5993C23.8004 15.1986 22.7679 17.6914 20.9299 19.5293L13.9999 26.4593L7.06993 19.5293C6.15981 18.6193 5.43785 17.5389 4.94529 16.3499C4.45274 15.1608 4.19922 13.8864 4.19922 12.5993C4.19922 11.3123 4.45274 10.0379 4.94529 8.8488C5.43785 7.65974 6.15981 6.57936 7.06993 5.66933ZM13.9999 15.3993C14.7425 15.3993 15.4547 15.1043 15.9798 14.5792C16.5049 14.0541 16.7999 13.3419 16.7999 12.5993C16.7999 11.8567 16.5049 11.1445 15.9798 10.6194C15.4547 10.0943 14.7425 9.79933 13.9999 9.79933C13.2573 9.79933 12.5451 10.0943 12.02 10.6194C11.4949 11.1445 11.1999 11.8567 11.1999 12.5993C11.1999 13.3419 11.4949 14.0541 12.02 14.5792C12.5451 15.1043 13.2573 15.3993 13.9999 15.3993Z",
    fill: "#06D6A0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2762891301e8002eda13541d0446e0f5.svg";
export { ForwardRef as ReactComponent };